import { useEffect, useRef } from 'react';

import { useSignIn } from 'components/GitHubButton';
import PageLoader from 'components/PageLoader';

const AuthGate = () => {
  const { signInWithGithub } = useSignIn();
  const triggered = useRef(false);

  useEffect(() => {
    if (!triggered.current) {
      triggered.current = true;
      signInWithGithub();
    }
  }, []);

  return <PageLoader />;
};

export default AuthGate;
